import * as SplashScreen from 'expo-splash-screen';
import { useEffect } from 'react';

type AnimatedSplashProps = {
  appIsReady: boolean;
};

export const AnimatedSplash = ({ appIsReady }: AnimatedSplashProps) => {
  useEffect(() => {
    if (appIsReady) {
      SplashScreen.hide();
    }
  }, [appIsReady]);

  return null;
};
